import { useAppDispatch, useAppSelector } from 'state/hooks';
import { resetSavedRoutes } from 'state/savedRouteSlices';
import { getProjectInfoForSlug, selectUser } from 'state/userSlice';
import { selectProject, setProjectSlug } from 'state/workflowSlice';

import { userHasProjectAccess } from 'features/app_header/ProjectSwitcher';
import { walkmeService } from 'features/login/WalkMe';

export const useProjectSlug = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(selectUser);
  const current = useAppSelector(selectProject);

  /**
   * This function should always be used to switch to a different project
   *
   * @param newProject
   */
  const setSlug = (newProject: string) => {
    const projectAccess = userHasProjectAccess(user, newProject);
    if (!projectAccess) {
      console.log('Project info not found for slug');
    }
    if (!newProject) {
      // Project info is empty meaning the user has lost access to this project
      newProject = undefined;
      for (let i = 0; i < user.projects.length; i++) {
        if (user.projects[i].is_default) {
          const default_project = user.projects[i].project_slug;
          console.log(
            `Setting project slug to be ${default_project} as default`,
          );
          newProject = default_project;
          break;
        }
      }
      if (!newProject && user.projects.length > 0) {
        newProject = user.projects[0].project_slug;
      }
    }
    if (newProject !== current) {
      walkmeService.setProjectVariables(
        getProjectInfoForSlug(user, newProject),
      );
      dispatch(resetSavedRoutes());
      dispatch(setProjectSlug(newProject));
    }
  };
  return { setSlug, current };
};
